import { Component, h, Prop, Listen, Element } from "@stencil/core";
import {
  validProductPrice,
  setInstallmentsByPrice,
  sendEvent,
  validMoClientId,
  removeMoIframe,
  createMoIframe,
} from "../../utils/utils";
import { environment } from "../../global/resources";
@Component({
  tag: "mo-product-page",
  styleUrl: "mo-product-page.css",
  shadow: true,
})
export class MoProductPage {
  @Element() el: HTMLElement;
  @Prop() moClientId!: string;
  @Prop() productPrice?: string;
  @Prop() offerType: string = "3";
  public urlBase: string = environment.base_url;
  @Listen("closeIframe", { target: "document" })
  closeIframeHandlerEvent(event: CustomEvent) {
    if (!!event) this.removeIframe();
  }

  componentDidLoad() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0,
    };
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          sendEvent("product", "view");
          observer.unobserve(entry.target);
        }
      });
    }, options);
    observer.observe(this.el);
  }
  private addIframe = (
    clientId: string,
    price: string,
    gtagCategory: string
  ) => {
    console.log(clientId);
    sendEvent(gtagCategory, "click");
    return !!validMoClientId(clientId)
      ? createMoIframe(clientId, price)
      : console.warn("Invalid MO Client ID");
  };
  private removeIframe = () => removeMoIframe();

  render() {
    return (
      <div class="mo-product-page">
        <div class="mo-product-page__text">
        <p>
          Paga desde <b>{this.offerType} cuotas</b> de &nbsp; 
          <b>
            {setInstallmentsByPrice(this.productPrice)} <br /> 
          </b>
        </p>
        <p>
        Plazos <b>sin intereses</b> con <b>todas las tarjetas de crédito. </b>
          <a
            href="javascript:void()"
            onClick={() =>
              this.addIframe(this.moClientId, this.productPrice, "product")
            }
          >
            <b>Más información</b>
            
          </a>
        </p>
        </div>
        <div class="mo-product-page__image">
          <img
            src={`${this.urlBase}/assets/Powerpay_Logo-Dark.png`}
            alt="Powerpay Logo"
          />
        </div>
        {/* <div class='mo-product-page__button'>
          <mo-button
            price={this.productPrice}
            buttonType='product'
            clientId={this.moClientId}
            offerByPrice={validProductPrice(this.productPrice)}
            gtagCategory='product'
          ></mo-button>
        </div> */}
      </div>
    );
  }
}

export interface IProduct {
  offerType: string;
  productValue: string;
}
